<template>
  <div>
    <div :class="`text-${field.textAlign}`">
      <span v-if="fieldHasValue" class="whitespace-nowrap">
        {{ formattedTime }}
      </span>
      <span v-else>&mdash;</span>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import { FieldValue } from '@/mixins'

export default {
  mixins: [FieldValue],

  props: ['resourceName', 'field'],

  computed: {
    formattedTime() {
      if (this.field.usesCustomizedDisplay) {
        return this.field.displayedAs
      }

      let isoTime = DateTime.fromISO(this.field.value)

      return isoTime.toLocaleString({
        hour: '2-digit',
        minute: '2-digit',
      })
    },
  },
}
</script>
